import useUser from '@src/composables/user'
import { watch } from 'vue'
import * as Sentry from '@sentry/vue'

export default function useSentryUserId() {
  const { user } = useUser()

  watch(user, (newUser, oldUser) => {
    if (oldUser?.event_tracking_id && oldUser.event_tracking_id !== newUser.event_tracking_id) {
      Sentry.setUser({ id: newUser.event_tracking_id })
    }
  }, { immediate: true })
}
